import { render, staticRenderFns } from "./AddNivel3.vue?vue&type=template&id=589a656e&"
import script from "./AddNivel3.vue?vue&type=script&lang=js&"
export * from "./AddNivel3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports